var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLiked(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.3502 17.1297C10.5902 17.8197 9.42015 17.8197 8.66015 17.1197L8.55015 17.0197C3.30015 12.2697 -0.129847 9.15968 0.000153087 5.27968C0.0601531 3.57968 0.930153 1.94968 2.34015 0.989677C4.98015 -0.810322 8.24015 0.0296776 10.0002 2.08968C11.7602 0.0296776 15.0202 -0.820322 17.6602 0.989677C19.0702 1.94968 19.9402 3.57968 20.0002 5.27968C20.1402 9.15968 16.7002 12.2697 11.4502 17.0397L11.3502 17.1297Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLiked);
export default __webpack_public_path__ + "static/media/Liked.8f4eb18fd38fc2c3fcd984de74cf0f99.svg";
export { ForwardRef as ReactComponent };